import {
    FETCH_ISSUE_INVOICE_LIST_FAILURE,
    FETCH_ISSUE_INVOICE_LIST_REQUEST,
    FETCH_ISSUE_INVOICE_LIST_SUCCESS,
} from './issueInvoice-actions';
import initialStates from '../../initialStates';

const issueInvoice = (state = initialStates.issueInvoice, action) => {
    let newState = {};
    switch (action.type) {
    case FETCH_ISSUE_INVOICE_LIST_REQUEST:
        newState = Object.assign({}, state, { isLoading: true });
        break;
    case FETCH_ISSUE_INVOICE_LIST_SUCCESS:
        newState = Object.assign({}, state, {
            isLoading: false,
            list: action.data.content,
            page: action.data.page,
            size: action.data.size,
            totalElements: action.data.totalElements,
            filters: action.filters,
            sortOrder: action.sortOrder,
            sortCol: action.sortCol,
            forwardSeekMap: action.data.forwardSeekMap,
            backwardSeekMap: action.data.backwardSeekMap,
            first: action.data.first,
            last: action.data.last,
        });
        break;
    case FETCH_ISSUE_INVOICE_LIST_FAILURE:
        newState = Object.assign({}, state, { isLoading: false });
        break;
    default:
        newState = state;
    }
    return newState;
};

export default issueInvoice;
